/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RedoIcon = ({ width = 24, height = 24, hidden = false, title = 'Redo' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M5.337 12.542A10.391 10.391 0 0 1 12.329 10H25V4.8a.8.8 0 0 1 .8-.8.787.787 0 0 1 .527.2l7.524 7.445a.5.5 0 0 1 0 .7L26.332 19.8a.787.787 0 0 1-.527.2.8.8 0 0 1-.8-.8V14H12.123A6.139 6.139 0 0 0 5.9 19.8 5.889 5.889 0 0 0 12 26h7a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6.526a10.335 10.335 0 0 1-10.426-9.013 9.947 9.947 0 0 1 3.289-8.445Z"
    />
  </svg>`;
};
